import React from "react";
import Icon1 from "../../images/equipments.svg";
import Icon2 from "../../images/money.svg";
import Icon3 from "../../images/trainer.svg";
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
} from "./ServiceStyles";
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";

function service() {
  return (
    <>
      <ServicesContainer id="services">
        <Flip left>
          <ServicesH1>Our Services</ServicesH1>
        </Flip>
        <ServicesWrapper>
          <ServicesCard>
            <Fade bottom>
              <ServicesIcon src={Icon2} />
              <ServicesH2>Medical Monitoring</ServicesH2>
              <ServicesP>
                You can monitor your healthy condition any time for free using
                our systems and get free nutritional counselling from our
                experts
              </ServicesP>
            </Fade>
          </ServicesCard>
          <ServicesCard>
            <Fade bottom>
              <ServicesIcon src={Icon3} />
              <ServicesH2>Gym Trainers</ServicesH2>
              <ServicesP>
                We have proffesiaonal gym coaches/trainers with over 30 years of
                experience who are ready to support you get your desired fitness
              </ServicesP>
            </Fade>
          </ServicesCard>
          <ServicesCard>
            <Fade bottom>
              <ServicesIcon src={Icon1} />
              <ServicesH2>Enough equpments</ServicesH2>
              <ServicesP>
                We have all the gym equipments needed in large quantity and our
                gym is spacious, therefore accomodate a large number of gym
                people
              </ServicesP>
            </Fade>
          </ServicesCard>
        </ServicesWrapper>
      </ServicesContainer>
    </>
  );
}

export default service;
